// src/routes/onboarding.routes.tsx
// Fixed: uses correct import path for createProtectedRoute
import { lazy } from 'react';
import { createProtectedRoute } from '@/routes/core/createProtectedRoute';
import type { AppRoute } from '@/routes/core/types';

const OnboardingCompanion = lazy(() => import('@/onboarding/companion/OnboardingCompanion'));

export const onboardingRoutes: AppRoute[] = [
  {
    id: 'onboarding.companion',
    domain: 'onboarding',
    path: '/onboarding',
    element: createProtectedRoute(<OnboardingCompanion />, {
      protected: true,
      meta: {
        title: 'Begin Your Journey — VisaGuide OS',
        description: 'Let me guide you through your immigration journey'
      }
    })
  }
];
